export default __webpack_public_path__ + "assets/ico_block_invite-90fa4c42.svg";